"use strict";

exports.__esModule = true;
var _DeviceColorSourcePicker = require("./DeviceColorSourcePicker");
Object.keys(_DeviceColorSourcePicker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceColorSourcePicker[key]) return;
  exports[key] = _DeviceColorSourcePicker[key];
});